import CreateUpdateOffice from './createUpdateOfficeContainer';

export default CreateUpdateOffice;
